module.exports = __webpack_public_path__ + "static/media/Anaplan-logo.cbaa69fd.png";